// 배너, 아이템, 태그 등등
import { apiClient } from "./axios";

const imageList = async () => {
  try {
    const res = await apiClient.get(`/api/v1/items`);
    console.log("resresres : ",res  )
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const bannerUpdate = async ({ bannerId, banner, bannerTitle }) => {
  try {
    const payload = {
      id: bannerId,
      image: banner,
    };
    if (typeof bannerTitle === "string") payload.title = bannerTitle;

    const res = await apiClient.post("/api/v1/items/update", payload);

    if (res?.data?.status === false) {
      console.error(res.data.error);
      return { IsError: true, error: res.data.error };
    }

    return { IsError: false, data: res?.data?.data ?? res?.data ?? null };
  } catch (error) {
    console.error(error);
    return { IsError: true, error: error?.message ?? String(error) };
  }
};

const bannerDelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/banner/delete", {
      banner_id: id,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const bannerCreate = async ({
  bannerUrl,
  bannerLocation,
  bannerLink,
  bannerPosition,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/banner/crate", {
      banner_url: bannerUrl,
      banner_location: bannerLocation,
      banner_link: bannerLink,
      banner_position: bannerPosition,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const productList = async ({ page }) => {
  try {
    const res = await apiClient.get(`/api/v1/admin/product/list?page=${page}`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    console.log(res.data);
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const productCreate = async ({
  productThumbnail,
  productTitle,
  productPrice,
  productLink,
  brandName,
  contentId,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/product/crate", {
      product_thumbnail: productThumbnail,
      product_title: productTitle,
      product_price: productPrice,
      product_link: productLink,
      brand_name: brandName,
      content_id: contentId,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const productUpdate = async ({
  productThumbnail,
  productTitle,
  productPrice,
  productLink,
  brandName,
  contentId,
  id,
  exposure,
}) => {
  try {
    const res = await apiClient.post("/api/v1/admin/product/update", {
      product_thumbnail: productThumbnail,
      product_title: productTitle,
      product_price: productPrice,
      product_link: productLink,
      brand_name: brandName,
      content_id: contentId,
      id: id,
      exposure: exposure,
    });
    console.log("update", res);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const productDelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/product/delete", {
      id: id,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return true;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const tagList = async ({ page }) => {
  try {
    const res = await apiClient.get(`/api/v1/admin/tag/list?page=${page}`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const tagCreate = async ({ tags }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/tag/create", {
      tag_name: tags.tag_name,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const tagDelete = async ({ id }) => {
  try {
    const res = await apiClient.post("/api/v1/admin/tag/delete", {
      tag_id: id,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const globalIndicators = async () => {
  try {
    const res = await apiClient.get("/api/v1/admin/traffic");
    if (!res.data.traffic.status) {
      console.error(res.data.traffic.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const subItemHooks = {
  globalIndicators,
  imageList,
  bannerUpdate,
  bannerDelete,
  bannerCreate,
  productList,
  productCreate,
  productUpdate,
  productDelete,
  tagList,
  tagCreate,
  tagDelete,
};

export default subItemHooks;
